import onboardingGetStarted from '../assets/images/onboardingGetStarted.png'
import onboardingGetStarted2x from '../assets/images/onboardingGetStarted@2x.png'

/**
 * OnboardingGetStartedIcon Component
 *
 * Displays the hand with pencil icon for the third onboarding slide.
 * Supports retina displays with @2x image asset.
 *
 * @example
 * <OnboardingGetStartedIcon />
 */
export const OnboardingGetStartedIcon = () => {
  return (
    <img
      src={onboardingGetStarted}
      srcSet={`${onboardingGetStarted} 1x, ${onboardingGetStarted2x} 2x`}
      alt="Get started - hand with pencil"
      className="onboarding-icon"
      width={148}
      height={148}
    />
  )
}
